import { render } from "./OpenLinkIcon.vue?vue&type=template&id=01f3ad3f"
import script from "./OpenLinkIcon.vue?vue&type=script&lang=js"
export * from "./OpenLinkIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/deployments/control-center.conneqt.io/new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__